import React from "react";
import ReactDOM from "react-dom/client";

import { App } from "./app/App";
import { registerSupportServiceWorker } from "./lib/registerServiceWorker";
import "./styles/global.css";

registerSupportServiceWorker();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
